

import { changePassword } from "api/Settings";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useChangePassword = () => {

    return useMutation(changePassword, {
        onSuccess: () => {

            toast.success("Changed Successfully");
        },
        onError: (e: any) => {
            if (e.response?.data?.message) {
                toast.error(e.response.data.message);
                return
            }
            if (e.response?.data?.error) {
                toast.error(e.response.data.error);
                return
            }
            toast.error(`Something went wrong`);
        },
    });
};
